import statusList from 'config/statusList';

export default (currentStatus, newStatus) => {
  const { confirmationRequiredStatuses } = statusList.find(
    ({ value }) => currentStatus === value,
  );

  return confirmationRequiredStatuses.includes(newStatus);
};
